export { ModelComponent } from "./ModelComponent";
export { ModelDecoratorsAngular2Model } from "./ModelDecoratorsAngular2Model";